import type { Context, User } from '@datadog/browser-core';
import type { Cleanup, InitRumOptions } from './types';

export type RumUser = Omit<User, 'id'> & Required<Pick<User, 'id'>>;

export interface SharedImpl {
    init(opts: InitRumOptions): { cleanup: Cleanup; initializedSdk: boolean };
    setServiceContext(key: string, context: Context): void;
}
